<script src="./_stats.js"></script>
<template src="./_stats.pug"></template>
<style src="./_stats.scss"></style>